// @flow
import * as ActionTypes from 'constants/ActionTypes';

// Get available try-on credit packages
export const getTryOnPackages = () => ({
  type: ActionTypes.GET_TRYON_PACKAGES_START,
});

export const getTryOnPackagesSuccess = (data) => ({
  type: ActionTypes.GET_TRYON_PACKAGES_SUCCESS,
  payload: data,
});

export const getTryOnPackagesFailure = (error) => ({
  type: ActionTypes.GET_TRYON_PACKAGES_FAILURE,
  payload: error,
});

// Get featured try-on credit packages
export const getTryOnFeaturedPackages = () => ({
  type: ActionTypes.GET_TRYON_FEATURED_PACKAGES_START,
});

export const getTryOnFeaturedPackagesSuccess = (data) => ({
  type: ActionTypes.GET_TRYON_FEATURED_PACKAGES_SUCCESS,
  payload: data,
});

export const getTryOnFeaturedPackagesFailure = (error) => ({
  type: ActionTypes.GET_TRYON_FEATURED_PACKAGES_FAILURE,
  payload: error,
});

// Verify checkout
export const verifyTryOnCheckout = (reqData) => ({
  type: ActionTypes.VERIFY_TRYON_CHECKOUT_START,
  payload: reqData,
});

export const verifyTryOnCheckoutSuccess = (data) => ({
  type: ActionTypes.VERIFY_TRYON_CHECKOUT_SUCCESS,
  payload: data,
});

export const verifyTryOnCheckoutFailure = (error) => ({
  type: ActionTypes.VERIFY_TRYON_CHECKOUT_FAILURE,
  payload: error,
});

// Create order
export const createTryOnOrder = (reqData) => ({
  type: ActionTypes.CREATE_TRYON_ORDER_START,
  payload: reqData,
});

export const createTryOnOrderSuccess = (data) => ({
  type: ActionTypes.CREATE_TRYON_ORDER_SUCCESS,
  payload: data,
});

export const createTryOnOrderFailure = (error) => ({
  type: ActionTypes.CREATE_TRYON_ORDER_FAILURE,
  payload: error,
});

// Complete order
export const completeTryOnOrder = (reqData) => ({
  type: ActionTypes.COMPLETE_TRYON_ORDER_START,
  payload: reqData,
});

export const completeTryOnOrderSuccess = (data) => ({
  type: ActionTypes.COMPLETE_TRYON_ORDER_SUCCESS,
  payload: data,
});

export const completeTryOnOrderFailure = (error) => ({
  type: ActionTypes.COMPLETE_TRYON_ORDER_FAILURE,
  payload: error,
});

// Get orders
export const getTryOnOrders = (reqData) => ({
  type: ActionTypes.GET_TRYON_ORDERS_START,
  payload: reqData,
});

export const getTryOnOrdersSuccess = (data) => ({
  type: ActionTypes.GET_TRYON_ORDERS_SUCCESS,
  payload: data,
});

export const getTryOnOrdersFailure = (error) => ({
  type: ActionTypes.GET_TRYON_ORDERS_FAILURE,
  payload: error,
});

// Get order detail
export const getTryOnOrderDetail = (orderId) => ({
  type: ActionTypes.GET_TRYON_ORDER_DETAIL_START,
  payload: orderId,
});

export const getTryOnOrderDetailSuccess = (data) => ({
  type: ActionTypes.GET_TRYON_ORDER_DETAIL_SUCCESS,
  payload: data,
});

export const getTryOnOrderDetailFailure = (error) => ({
  type: ActionTypes.GET_TRYON_ORDER_DETAIL_FAILURE,
  payload: error,
});

// Create payment order
export const createTryOnPaymentOrder = (reqData) => ({
  type: ActionTypes.CREATE_TRYON_PAYMENT_ORDER_START,
  payload: reqData,
});

export const createTryOnPaymentOrderSuccess = (data) => ({
  type: ActionTypes.CREATE_TRYON_PAYMENT_ORDER_SUCCESS,
  payload: data,
});

export const createTryOnPaymentOrderFailure = (error) => ({
  type: ActionTypes.CREATE_TRYON_PAYMENT_ORDER_FAILURE,
  payload: error,
});

// Verify payment
export const verifyTryOnPayment = (reqData) => ({
  type: ActionTypes.VERIFY_TRYON_PAYMENT_START,
  payload: reqData,
});

export const verifyTryOnPaymentSuccess = (data) => ({
  type: ActionTypes.VERIFY_TRYON_PAYMENT_SUCCESS,
  payload: data,
});

export const verifyTryOnPaymentFailure = (error) => ({
  type: ActionTypes.VERIFY_TRYON_PAYMENT_FAILURE,
  payload: error,
});
